import { FETCH_SYNCED_BILLS } from "../constants/endpoints";
import axiosClient from "./axios";
import type { FetchBillsRequest, FetchBillsResponseData } from "../views/BillManagement/types";

class fetchSyncedBillsService {
    static async fetchSyncedBills(
        shopId: string,
        request: FetchBillsRequest = {}
    ): Promise<{ data: { result: { data: FetchBillsResponseData } } }> {
        const { page = 1, limit = 40, filters = {} } = request;

        // Build request payload - filters are sent to server for server-side filtering
        const payload = {
            page,
            limit,
            filters,
        };

        // Build endpoint URL
        const endpoint = FETCH_SYNCED_BILLS.replace("{shopId}", shopId);

        const response = await axiosClient.post(endpoint, payload);
        return response;
    }
}

export default fetchSyncedBillsService;
